__turbopack_context__.v({
  "docsItem": "Nav-module__e1xquq__docsItem",
  "docsLabel": "Nav-module__e1xquq__docsLabel",
  "docsNav": "Nav-module__e1xquq__docsNav",
  "header": "Nav-module__e1xquq__header",
  "link": "Nav-module__e1xquq__link",
  "logo": "Nav-module__e1xquq__logo",
  "menu": "Nav-module__e1xquq__menu",
  "menuOpen": "Nav-module__e1xquq__menuOpen",
  "menuToggle": "Nav-module__e1xquq__menuToggle",
  "nav": "Nav-module__e1xquq__nav",
});
